import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "demand-calendar__header" };
const _hoisted_2 = { class: "demand-calendar__filter" };
const _hoisted_3 = { class: "demand-calendar__search" };
const _hoisted_4 = ["title"];
const _hoisted_5 = {
    key: 0,
    class: "demand-calendar__download"
};
const _hoisted_6 = { class: "demand-calendar__days" };
const _hoisted_7 = { class: "demand-calendar__day-comp" };
const _hoisted_8 = { class: "demand-calendar__day-comp demand-calendar__day-comp--date" };
const _hoisted_9 = { class: "demand-calendar__content" };
const _hoisted_10 = { class: "demand-calendar__articles" };
const _hoisted_11 = { class: "demand-calendar__article-groups" };
const _hoisted_12 = {
    key: 0,
    class: "demand-calendar__no-articles"
};
const _hoisted_13 = { class: "demand-calendar__main" };
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import moment from 'moment';
import DemandArticleGroup from "./DemandArticleGroup.vue";
import DemandDayInputGroup from "./DemandDayInputGroup.vue";
import { updateDemandItem } from "../commands/UpdateDemandItem";
import CatalogSearchInput from "./CatalogSearchInput.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import Pagination from "@astina/paloma-common-ui/src/components/Pagination.vue";
import config from '../services/PortalConfig';
import DownloadDemandDocument from "../commands/DownloadDemandDocument";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DemandCalendar',
    props: {
        data: {},
        searchRequest: {},
        searchFilters: {}
    },
    emits: ['searchRequestUpdate'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const sections = computed(() => {
            // group by category TODO configurable?
            const groups = new Map();
            for (const variant of props.data.variants.content) {
                const category = variant.variant.category || '-';
                if (!groups.has(category)) {
                    groups.set(category, []);
                }
                groups.get(category).push(variant);
            }
            return Array.from(groups.entries()).map(([category, variants]) => ({
                title: category,
                variants,
            }));
        });
        const calendarRef = ref(null);
        const dayRefs = ref([]);
        // periodically update 'now' to refresh UI components
        const now = ref(new Date());
        let refreshInterval = 0;
        let initialized = false;
        onMounted(async () => {
            refreshInterval = window.setInterval(() => {
                now.value = new Date();
            }, config.demand.refreshRate);
            if (!initialized) {
                await nextTick();
                scrollToToday();
                initialized = true;
            }
        });
        onUnmounted(() => {
            refreshInterval && window.clearInterval(refreshInterval);
        });
        const hoveredVariant = ref(null);
        function onVariantHover(variant) {
            hoveredVariant.value = variant;
        }
        function onVariantQuantityChange(variant, quantity, targetDate) {
            const orderingUnit = variant.orderingUnits[0]; // TODO
            // TODO move this to DemandView
            updateDemandItem({
                sku: variant.id,
                unit: orderingUnit.unitCode,
                quantity: quantity.quantity,
                portions: quantity.portions,
                targetDate,
            })
                .catch(() => {
                // TODO reset item
            });
        }
        // Manually re-run search
        function onSearchRefresh() {
            emit('searchRequestUpdate', { ...props.searchRequest });
        }
        function onPageChange(page) {
            const newSearchRequest = { ...props.searchRequest };
            newSearchRequest.page = page;
            emit('searchRequestUpdate', newSearchRequest);
        }
        function formatDateWeekday(date) {
            return moment(date).format('dddd');
        }
        function formatDate(date) {
            return moment(date).format('DD.MM.');
        }
        function scrollToToday() {
            const today = moment().format('YYYY-MM-DD');
            const index = props.data.days.findIndex(d => moment(d).format('YYYY-MM-DD') === today);
            if (index !== -1 && dayRefs.value[index] && calendarRef.value) {
                const el = dayRefs.value[index];
                const container = calendarRef.value;
                const elLeft = el.offsetLeft;
                // actual visible left edge of scroll area
                const articlesWidth = container.querySelector('.demand-calendar__articles')?.clientWidth || 0;
                container.scrollTo({
                    left: elLeft - articlesWidth,
                    behavior: 'instant'
                });
            }
        }
        const downloadDemandDocument = computed(createDownloadDemandDocument);
        function createDownloadDemandDocument() {
            return new DownloadDemandDocument(props.searchRequest);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "demand-calendar",
                ref_key: "calendarRef",
                ref: calendarRef
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(CatalogSearchInput, {
                                "search-request": __props.searchRequest,
                                filters: __props.searchFilters,
                                onUpdate: _cache[0] || (_cache[0] = (sr) => emit('searchRequestUpdate', sr))
                            }, null, 8, ["search-request", "filters"]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("button", {
                                type: "button",
                                class: "demand-calendar__search-button",
                                title: _ctx.$t('demand.refresh_search'),
                                onClick: onSearchRefresh
                            }, [
                                _createVNode(Icon, { name: "search" })
                            ], 8, _hoisted_4)
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        (_unref(config).demand.showDownloadDemandData)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (downloadDemandDocument.value)
                                    ? (_openBlock(), _createBlock(CommandButton, {
                                        key: 0,
                                        command: downloadDemandDocument.value,
                                        label: "",
                                        classes: "button button--light"
                                    }, null, 8, ["command"]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.days, (date) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: date,
                                class: "demand-calendar__day"
                            }, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(formatDateWeekday(date)), 1),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_8, _toDisplayString(formatDate(date)), 1)
                            ]));
                        }), 128))
                    ])
                ]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section, index) => {
                                return (_openBlock(), _createBlock(DemandArticleGroup, {
                                    key: index,
                                    title: section.title,
                                    variants: section.variants,
                                    onVariantHover: onVariantHover,
                                    "hovered-variant": hoveredVariant.value,
                                    class: "demand-calendar__section"
                                }, null, 8, ["title", "variants", "hovered-variant"]));
                            }), 128))
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createVNode(Pagination, {
                            page: __props.data.variants,
                            onChange: onPageChange
                        }, null, 8, ["page"]),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        (__props.data.variants.totalElements === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('demand.no_articles_found')), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.days, (date, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: date,
                                class: "demand-calendar__day",
                                ref_for: true,
                                ref: el => dayRefs.value[i] = el
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section, index) => {
                                    return (_openBlock(), _createBlock(DemandDayInputGroup, {
                                        key: index,
                                        variants: section.variants,
                                        date: date,
                                        now: now.value,
                                        "hovered-variant": hoveredVariant.value,
                                        onHover: onVariantHover,
                                        onVariantQuantityChange: (variant, quantity) => onVariantQuantityChange(variant, quantity, date),
                                        class: "demand-calendar__day-input-group"
                                    }, null, 8, ["variants", "date", "now", "hovered-variant", "onVariantQuantityChange"]));
                                }), 128))
                            ]));
                        }), 128))
                    ])
                ])
            ], 512));
        };
    }
});
